import { faTag } from '@fortawesome/pro-light-svg-icons';
import cuid from 'cuid';
import gql from 'graphql-tag';

const MetadataReadingSkill = {
  searchFragment: gql`
        fragment searchMetadataReadingSkill on MetadataTag {
          id
          name
          tagTitle
          tagDescription
          tagDisplayName
          tagType
          hierarchy
          createdAt
          updatedAt
          hasDerivedStandards
        }
      `,
  fullFragment: gql`
        fragment fullMetadataReadingSkill on MetadataTag { 
        id
        name
        tagTitle
        tagDescription
        tagDisplayName
        tagType
        hierarchy
        certicaId
        origin
        createdAt
        updatedAt
        hasDerivedStandards
        }
    `,

  defaults: (id, data = {}) => {
    const tagId = id || cuid();
    const tagTitle = data.newLabel || null;

    return {
      client: {
        id: tagId,
        __typename: 'MetadataTag',
        tagType: 'PUBLIC_TAG',
        name: tagTitle || 'MetadataReadingSkill',
        tagTitle,
        tagDescription: null,
        tagDisplayName: null,
        hasDerivedStandards: false,
        hierarchy: [],
        certicaId: null,
        origin: 'HUMAN',
        createdAt: (new Date()).toISOString(),
        updatedAt: (new Date()).toISOString(),
        assignedCount: 0
      },
      server: {
        id,
        tagTitle
      }
    };
  },
  icon: faTag,
  typename: 'MetadataReadingSkill',
  openInApp: false,
  forms: {},
  inputs: {
    readingSkillTags: {
      input: 'select',
      name: 'metadataReadingSkills',
      label: 'Reading Skills',
      isMulti: true,
      isAsync: true,
      isRelation: true,
      isMetadataService: true,
      type: 'MetadataReadingSkill',
      tooltipText: 'Newsela defined reading skills, each reading skill is mapped to a single grade level ELA standard in grades 2-12 in the reading skills crosswalk.',
      tooltipFeaturesPowered: 'Standards displayed on Newsela quiz questions.',
      query: 'searchMetadataReadingSkills',
      showDropdown: false,
      mapping: {
        label: 'tagTitle',
        value: 'id',
        type: 'tagType',
        path: 'hierarchy',
        hasDerivedStandards: 'hasDerivedStandards',
      }
    }
  },

};
export default MetadataReadingSkill;
